module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Broom-2e779af16083ffbff302878bf80ed841.svg";